export default "__VITE_ASSET__a7e02118__"